import React from 'react';

import {
  KSFStatusEnum,
  SalesInvoiceStatusEnum,
} from '../../../common/pokCore/validation/enums';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import {
  CreateUpdateSalesInvoiceDtoStatusEnum,
  CreateUpdateSalesInvoiceDtoStatusKsefEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SalesInvoiceDeactivateConfirmProps {
  invoiceStatus: CreateUpdateSalesInvoiceDtoStatusEnum;
  statusKsef?: CreateUpdateSalesInvoiceDtoStatusKsefEnum;
  isDeactivated?: boolean;
  handleRemove: () => void;
  disabled: boolean;
}

export const SalesInvoiceDeactivateConfirm: React.FC<
  SalesInvoiceDeactivateConfirmProps
> = ({ invoiceStatus, statusKsef, isDeactivated, handleRemove, disabled }) => {
  const { t, tk } = useTranslation('fvsLng');
  if (
    invoiceStatus !== SalesInvoiceStatusEnum.Draft ||
    isDeactivated ||
    statusKsef === KSFStatusEnum.RejectedInKSeF
  ) {
    return;
  }

  return (
    <ConfirmationButton
      onOK={handleRemove}
      confirmation={t(tk.finance.askDeleteInvoiceDraft)}
      variant="outline-danger"
      disabled={disabled}
    >
      {t(tk.button.delete)}
    </ConfirmationButton>
  );
};
